import { isTextNode } from './htmlEditorUtils.js';

const walkNodes = (node, visit) => {
  if (!node) return;
  visit(node);
  if (isTextNode(node)) return;
  (node.children || []).forEach((child) => walkNodes(child, visit));
};

export const getNodeText = (node) => {
  let content = '';
  walkNodes(node, (current) => {
    if (isTextNode(current)) content += current.content;
  });
  return content.trim();
};

const findProjectField = (projectNode, fieldName) => {
  let match = null;
  walkNodes(projectNode, (node) => {
    if (!match && node?.attributes?.['data-project-field'] === fieldName) {
      match = node;
    }
  });
  return match;
};

export const findProjectNodeByRecordId = (root, projectId) => {
  let match = null;
  walkNodes(root, (node) => {
    if (
      !match
      && node?.attributes?.['data-managed-role'] === 'project-item'
      && node?.attributes?.['data-project-id'] === projectId
    ) {
      match = node;
    }
  });
  return match;
};

export const getProjectDetail = (projectNode) => {
  if (!projectNode) return null;

  const titleNode = findProjectField(projectNode, 'title');
  const overviewNode = findProjectField(projectNode, 'overview');
  const linkNode = findProjectField(projectNode, 'project-url');
  const images = [];
  const skills = [];

  walkNodes(projectNode, (node) => {
    if (node?.attributes?.['data-managed-role'] !== 'project-image') return;
    const imageNode = findProjectField(node, 'image');
    const captionNode = findProjectField(node, 'image-caption');
    if (!imageNode?.attributes?.src) return;
    images.push({
      id: node.attributes?.['data-image-id'] || imageNode.id,
      src: imageNode.attributes.src,
      alt: imageNode.attributes.alt || getNodeText(captionNode) || 'Project image',
      description: getNodeText(captionNode) || imageNode.attributes.alt || '',
    });
  });

  walkNodes(projectNode, (node) => {
    if (node?.attributes?.['data-managed-role'] !== 'project-skill') return;
    const iconNode = findProjectField(node, 'skill-icon');
    const imageIcon = iconNode?.type === 'img' ? iconNode : null;
    const bootstrapIcon = iconNode?.type === 'span'
      ? (iconNode.children || []).find((child) => child?.type === 'i')
      : null;
    const iconClass = (bootstrapIcon?.attributes?.class || []).find((className) => (
      /^bi-[a-z0-9-]+$/.test(className)
    ));
    skills.push({
      id: String(node.attributes?.['data-project-skill-id'] || node.id),
      name: getNodeText(node) || 'Untitled skill',
      iconClass: iconClass || '',
      imageSrc: imageIcon?.attributes?.src || '',
    });
  });

  const href = String(linkNode?.attributes?.href || '').trim();
  return {
    id: String(projectNode.attributes?.['data-project-id'] || projectNode.id),
    title: getNodeText(titleNode) || 'Untitled project',
    description: getNodeText(overviewNode),
    href: href && href !== '#' ? href : '',
    images,
    skills,
  };
};
